<template>
  <div>
    <div v-if="!hasResults">
      <v-alert type="info">
        {{ $t('reports_ui.no_data_for_period') }}
      </v-alert>
    </div>
    <div v-else>
      <!-- Customer Results -->
      <div v-for="(customerResult, customerId) in report.results" :key="customerId">
        <forecast-violation-validation-report-card
          :customer-result="customerResult"
          :start-date="report.parameters.startDate"
          :end-date="report.parameters.endDate"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ReportRecord from '@/orm/models/ReportRecord'
import ForecastViolationValidationReportCard from '@/components/report/ForecastViolationValidationReportCard'
import { get, isEmpty } from 'lodash'

export default {
  name: 'ForecastViolationValidationReport',
  components: {
    ForecastViolationValidationReportCard
  },
  props: {
    report: {
      type: ReportRecord,
      required: true
    }
  },
  computed: {
    hasResults () {
      return !isEmpty(this.report.results)
    }
  }
}
</script>

<style scoped>
</style>
